import moment from "moment";
import * as Yup from "yup";
export const postiveNagtiveRadio = [
    { value: 0, label: "Postive" },
    { value: 1, label: "Negative" },
]

export const appearanceRadio = [
    { value: 0, label: "Milky" },
    { value: 1, label: "No Aggregates" },
]

export const validationSchemaCOAComment = Yup.object().shape({
    comment: Yup.string()
        .required("Comment is required")
        .max(200, "Enter less than 200 characters"),
});

export const coaFormValues = {
    storage_condition: "-80±10°C",
    specification_no: "SPC/C01/CT/01-00",
    rcl_qpcr: 0,
    sterility_culture_method_bactec: 0,
    multiplex_viral_test_pcr: 0,
    mycoplasma_pcr: 0,
    appearance: 0,
    car_surface_expression_flow_cytometry: null,
    cell_viability_dye_exclusion_method: null,
    cd19_viable_cell_detection_flow_cytometry: null,
    detection_of_magnetic_beads_microscope: "",
    endotoxin_level: null,
    vector_copy_number_vcn_qpcr: null,
    remarks: "",
    lead_remarks: "",
    qa_remarks:""
}



export const coaFormValidationSchema = (qcLeadRemark=false,canShowQaRemarks=false) =>{
    return Yup.object().shape({

    batch_no: Yup.string()
        .max(50, "Batch No cannot exceed 50 characters")
        .required("Batch No is required"),

    storage_condition: Yup.string()
        .required("Storage Condition is required"),

    specification_no: Yup.string()
        .required("Specification No is required"),

    // Binary test results: 0 = Negative, 1 = Positive
    rcl_qpcr: Yup.number()
        .oneOf([0, 1], "Must be 0 or 1")
        .required("RCL qPCR result is required"),

    sterility_culture_method_bactec: Yup.number()
        .oneOf([0, 1], "Must be 0 or 1")
        .required("Sterility Culture result is required"),

    multiplex_viral_test_pcr: Yup.number()
        .oneOf([0, 1], "Must be 0 or 1")
        .required("Multiplex Viral Test result is required"),

    mycoplasma_pcr: Yup.number()
        .oneOf([0, 1], "Must be 0 or 1")
        .required("Mycoplasma PCR result is required"),

    appearance: Yup.number()
        .oneOf([0, 1], "Must be 0 or 1")
        .required("Appearance is required"),


    car_surface_expression_flow_cytometry: Yup.number()
        .min(0, "Must be ≥ 0")
        .required("CAR Surface Expression is required").nullable(),

    cell_viability_dye_exclusion_method: Yup.number()
        .min(0, "Must be ≥ 0")
        .required("Cell Viability is required").nullable(),

    cd19_viable_cell_detection_flow_cytometry: Yup.number()
        .min(0, "Must be ≥ 0")
        .required("CD19 Viable Cell Detection is required").nullable(),

    detection_of_magnetic_beads_microscope: Yup.string()
        .required("Magnetic Beads Detection is required"),

    endotoxin_level: Yup.number()
        .min(0, "Must be ≥ 0")
        .required("Endotoxin Level is required").nullable(),

    vector_copy_number_vcn_qpcr: Yup.number()
        .min(0, "Must be ≥ 0")
        .required("Vector Copy Number is required").nullable(),

    remarks: Yup.string()
        .required("Remarks are required"),
     ...(qcLeadRemark
    ? {
        lead_remarks: Yup.string()
         .nullable() 
          .trim()
          .required("Remarks are required"),
      }
    : {}),
 ...(canShowQaRemarks
    ? {
        qa_remarks: Yup.string()
         .nullable() 
          .trim()
          .required("Remarks are required"),
      }
    : {}),
    expired_at: Yup.date()
        .transform((value, originalValue) => {
            // If already a Date, return as is
            if (value instanceof Date && !isNaN(value)) return value;

            // Parse using moment with your format
            const parsed = moment(originalValue, "DD/MM/YYYY", true);
            return parsed.isValid() ? parsed.toDate() : new Date("");
        })
        .typeError("Expiry Date must be a valid date (DD/MM/YYYY)")
        .required("Expiry Date is required")
});
}
